// Gatsby browser code
import './src/theme/theme.scss';

// You can also wrap with TSX components like so
import AppProvider from './src/context/appProvider';
export const wrapRootElement = AppProvider;
